import styled, { keyframes } from 'styled-components';

const GRID_COLUMNS = '1fr 140px 180px';
const GRID_GAP = '40px';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

export const Spinner = styled.div<{ size?: string; color?: string }>`
	width: ${props => props.size || '40px'};
	height: ${props => props.size || '40px'};
	border: 3px solid ${props => props.color || '#eafaf1'};
	border-top: 3px solid
		${props => (props.color === 'white' ? 'white' : '#0a8f44')};
	border-radius: 50%;
	animation: ${rotate} 0.8s linear infinite;
`

export const LoaderWrapper = styled.div`
	display: flex;
	min-height: 400px;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 50px;
	gap: 15px;
	color: #0a8f44;
	font-weight: 500;
`

export const TableContainer = styled.div`
	width: 100%;
	max-width: 1440px;
	margin: 0 auto 80px auto;
	font-family: sans-serif;
	color: #374151;
	font-size: 13px;
	min-height: 600px;
	padding: 0 5px;
	box-sizing: border-box;
	 position: relative;
`

export const Header = styled.div`
	display: grid;
	  grid-template-columns: ${GRID_COLUMNS};
	padding: 10px 15px;
	border-bottom: 1px solid #d9d9d9;
	border-top: 1px solid #d9d9d9;
     gap: 40px;
	margin-bottom: 20px;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 11px;
	text-transform: lowercase;
	color: #8f8f8f;

	@media (max-width: 768px) {
    display: none;  
  }
`

export const Card = styled.div`
	margin-bottom: 10px;
	border-radius: 4px;
	overflow: hidden;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`

export const CardMain = styled.div<{ $isEmergency: boolean }>`
  display: grid;
  grid-template-columns: ${GRID_COLUMNS};
  gap: 40px;
  align-items: center;
  padding: 15px;
  border-radius: 20px 19px 0 0;
  background-color: ${props => props.$isEmergency ? '#ffdede' : '#e0ebff'};
  cursor: pointer;

    @media (max-width: 768px) {
    grid-template-columns: 1fr;  
    gap: 8px;
    border-radius: 12px 12px 0 0;
  }
`

export const Title = styled.div`
	margin-bottom: 10px;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #000;

	@media(max-width: 1024px) {
	  font-size: 13px;
	}
	
`

export const RowText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #555;
`

export const DetailsArea = styled.div`
	padding: 15px;
	background-color: #f8f8f8;
	border-top: 1px solid rgba(0, 0, 0, 0.05);
	border-bottom: 1px solid #ffdede;
	border-left: 1px solid #ffdede;
	border-right: 1px solid #ffdede;
`

export const DetailBlock = styled.div`
	margin-bottom: 15px;
`

export const Label = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 13px;
	color: #8f8f8f;
	margin-bottom: 11px;
`

export const Content = styled.div`
    white-space: pre-wrap;
    font-family: "e-Ukraine", sans-serif;
    font-weight: 400;
    font-size: 15px;
    color: #000
    line-heigth: 20px;
    padding-left: 30px;

	@media(max-width: 530px) {
	 padding-left: 0px;
	}
`

export const LoadMoreButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;

	margin: 20px auto;
	font-weight: 500;
	font-size: 15px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #01924f;
	background: transparent;

	font-family: 'e-Ukraine', sans-serif;

	border: none;
	cursor: pointer;

	&:disabled {
		opacity: 0.6;
	}
`
export const EmptyState = styled.div`
	display: flex;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 300;
	font-size: 20px;
	color: #383838;
	align-items: center;
	justify-content: center;
	flex: 1;
	min-height: 400px;
	text-align: center;
	border: 1px dashed #ccc;
	border-radius: 12px;
	margin-top: 20px;

	@media(max-width: 768px) {
	font-size: 15px;
	}

	@media(max-width: 425px) {
	font-size: 12px;
	}
`

export const MobileLabel = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    font-family: 'e-Ukraine', sans-serif;
    font-size: 11px;
    color: #8f8f8f;
    margin-bottom: 2px;
  }
`